import { Navigate } from "react-router";
import { isPathAllowed } from "../../shared/rbac";
import { useAllowedPages } from "../hooks/use-rbac";

/**
 * Page gate for authenticated routes rendered outside AppShell. AppShell owns
 * this check for normal pages; full-screen routes such as /display must apply
 * the same allowed_pages boundary explicitly.
 */
export function RequirePageAccess({
  path,
  children,
}: {
  path: string;
  children: React.ReactNode;
}) {
  const pages = useAllowedPages();
  if (pages === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm">Loading access…</div>
      </div>
    );
  }
  if (!isPathAllowed(path, pages)) {
    return <Navigate to="/pending" replace />;
  }
  return <>{children}</>;
}
